define('lib/Podio.UI.Tooltips',['require','underscore','jquery','lib/jquery/jquery.bounds','lib/view_helpers/base','lib/Podio.Transport','lib/Podio.Event.UI','jst!tooltips/_end_membership','jst!tooltips/_headline_subline','jst!tooltips/_hotkey','jst!tooltips/_list','jst!tooltips/_contact_list','jst!tooltips/_no_name','jst!tooltips/_presence','jst!tooltips/_question','jst!tooltips/_roles_comparison','jst!tooltips/_setup_emp_network','jst!tooltips/_space_nav','jst!tooltips/_members_count','jst!tooltips/_calendar_event'],function(require) {

  var _ = require('underscore');
  var $ = require('jquery');
  require('lib/jquery/jquery.bounds');
  var viewHelpers = require('lib/view_helpers/base');
  var transport = require('lib/Podio.Transport');
  var eventUI = require('lib/Podio.Event.UI');

  var scrollEventBound = false;

  var jstTemplates = {
    end_membership: require('jst!tooltips/_end_membership'),
    headline_subline: require('jst!tooltips/_headline_subline'),
    hotkey: require('jst!tooltips/_hotkey'),
    list: require('jst!tooltips/_list'),
    contact_list: require('jst!tooltips/_contact_list'),
    no_name: require('jst!tooltips/_no_name'),
    presence: require('jst!tooltips/_presence'),
    question: require('jst!tooltips/_question'),
    roles_comparison: require('jst!tooltips/_roles_comparison'),
    setup_emp_network: require('jst!tooltips/_setup_emp_network'),
    space_nav: require('jst!tooltips/_space_nav'),
    members_count: require('jst!tooltips/_members_count'),
    calendar_event: require('jst!tooltips/_calendar_event')
  };

  // tipsy, facebook style tooltips for jquery
  // version 1.0.0a
  // (c) 2008-2010 jason frame [jason@onehackoranother.com]
  // released under the MIT license

  var options = {
    className: null,
    fade: false,
    fallback: '',
    gravity: 'n',
    html: false,
    offset: 0,
    opacity: 0.8,
    title: 'title',
    trigger: 'hover',
    selector: '.tooltip',
    maxWidth: 0
  };

  function maybeCall(thing, ctx) {
    return (typeof thing == 'function') ? (thing.call(ctx)) : thing;
  }

  function Tipsy(element, options) {
    this.$element = $(element);
    this.options = options;
    this.enabled = true;
    this.fixTitle();
  }

  Tipsy.prototype = {

    clearRemoteData: function() {
      this.options.templateData = null;
    },

    show: function() {
      var title = this.getTitle();
      if (this.enabled) {
        var $tip = this.tip();

        if (this.options.html) {

          var inner = viewHelpers.render(jstTemplates[this.options.templateName], {
            title: title,
            data: this.options.templateData
          });

          if (_.isEmpty($.trim(inner))) {
            return false;
          }

          if (this.options.convertNewLines) {
            inner = $.trim(inner).replace(/\n/g, "<br>");
          }

          $tip.find('.tipsy-inner').html(inner);
        } else {
          if (_.isEmpty(title)) {
            return false;
          }
          $tip.find('.tipsy-inner').text(title);
        }

        $tip[0].className = 'tipsy'; // reset classname in case of dynamic gravity
        $tip.remove().css({top: 0, left: 0, visibility: 'hidden', display: 'block'}).prependTo(document.body);

        if(this.options.imageTip) {
          $tip.addClass('image');
        } else {
          $tip.removeClass('image');
        }

        if(this.options.datetimeTip) {
          $tip.addClass('datetime');
        } else {
          $tip.removeClass('datetime');
        }

        if(this.options.style) {
          $tip.addClass(this.options.style);
        }

        if(this.options.maxWidth) {
          $tip.css('maxWidth', this.options.maxWidth);
        }

        if (this.options.className) {
          $tip.addClass(maybeCall(this.options.className, this.$element[0]));
        }

        var pos = $.extend({}, this.$element.offset(), {
          width: this.$element[0].offsetWidth,
          height: this.$element[0].offsetHeight
        });

        var actualWidth = $tip[0].offsetWidth,
            actualHeight = $tip[0].offsetHeight,
            gravity = maybeCall(this.options.gravity, [this.$element[0]]);
        var tp;
        switch (gravity.charAt(0)) {
          case 'n':
            tp = {top: pos.top + pos.height + this.options.offset, left: pos.left + pos.width / 2 - actualWidth / 2};
            break;
          case 's':
            tp = {top: pos.top - actualHeight - this.options.offset, left: pos.left + pos.width / 2 - actualWidth / 2};
            break;
          case 'e':
            tp = {top: pos.top + pos.height / 2 - actualHeight / 2, left: pos.left - actualWidth - this.options.offset};
            break;
          case 'w':
            tp = {top: pos.top + pos.height / 2 - actualHeight / 2, left: pos.left + pos.width + this.options.offset};
            break;
        }

        if (gravity.length == 2) {
          if (gravity.charAt(1) == 'w') {
            tp.left = pos.left + pos.width / 2 - 15;
          } else {
            tp.left = pos.left + pos.width / 2 - actualWidth + 15;
          }
        }

        $tip.css(tp).addClass('tipsy-' + gravity);
        $tip.find('.tipsy-arrow')[0].className = 'tipsy-arrow tipsy-arrow-' + gravity.charAt(0);
        $tip.find('.tipsy-arrow-border')[0].className = 'tipsy-arrow-border tipsy-arrow-border-' + gravity.charAt(0);

        if (this.options.fade) {
          $tip.stop().css({opacity: 0, display: 'block', visibility: 'visible'}).animate({opacity: this.options.opacity});
        } else {
          $tip.css({visibility: 'visible', opacity: this.options.opacity});
        }
      }

      // bind scroll event to hide tooltips
      if (!scrollEventBound) {
        scrollEventBound = true;
        $(window).bind('scroll', onScroll);
      }
    },

    hide: function() {
      if (this.options.fade) {
        this.tip().stop().fadeOut(function() {
          $(this).remove();
        });
      } else {
        this.tip().remove();
      }
    },

    fixTitle: function() {
      var $e = this.$element;
      if ($e.attr('title') || typeof($e.attr('data-original-title')) != 'string') {
        $e.attr('data-original-title', $e.attr('title') || '').removeAttr('title').attr("title", "");
      }
    },

    getTitle: function() {
      var title, $e = this.$element, o = this.options;
      this.fixTitle();
      if (typeof o.title == 'string') {
        title = $e.attr(o.title == 'title' ? 'data-original-title' : o.title);
        title = _.unescape(title);
      } else if (typeof o.title == 'function') {
        title = o.title.call($e[0]);
      }

      title = ('' + title).replace(/(^\s*|\s*$)/, "");
      return title || o.fallback;
    },

    clearTimer : function() {
      if( this.timer ) {
        clearTimeout(this.timer);
      }
    },

    tip: function() {
      if (!this.$tip) {
        this.$tip = $('<div class="tipsy"></div>').html('<div class="tipsy-arrow-border"></div><div class="tipsy-arrow"></div><div class="tipsy-inner"></div>');
      }
      return this.$tip;
    },

    validate: function() {
      if (!this.$element[0].parentNode) {
        this.hide();
        this.$element = null;
        this.options = null;
      }
    },

    enable: function() {
      this.enabled = true;
    },

    disable: function() {
      this.enabled = false;
    },

    toggleEnabled: function() {
      this.enabled = !this.enabled;
    }

  };

  function get(ele) {
    var elmTarget = $(ele);

    var gravity;
    if(elmTarget.hasClass('tooltip-gravity-ne')) {
      gravity = 'ne';
    } else if(elmTarget.data('tooltip-gravity')) {
      gravity = elmTarget.data('tooltip-gravity');
    } else {
      gravity = gravityAutoBounds;
    }

    var className = elmTarget.data('tooltip-class');
    var tooltipStyle = elmTarget.data('tooltip-style');
    var maxWidth = elmTarget.data('tooltip-max-width');
    var offset = elmTarget.data('tooltip-offset');
    var opacity = elmTarget.data('tooltip-opacity');
    if (!opacity) {
      opacity = className && className.indexOf('light') > -1 ? 0.9 : 0.8; // HACK: Higher opacity for light variant
      opacity = tooltipStyle && tooltipStyle.indexOf('light') > -1 ? 0.9 : opacity; // HACK: Higher opacity for light variant
    }

    var currentOptions = $.extend({}, options, {
      html: elmTarget.hasClass('tooltip-html'),
      isRemote: elmTarget.hasClass('tooltip-remote'),
      isDelayed: elmTarget.hasClass('tooltip-delayed'),
      delayInMs: elmTarget.data('tooltip-delay-in-ms'),
      imageTip : elmTarget.hasClass('tooltip-image'),
      datetimeTip : elmTarget.hasClass('tooltip-datetime'),
      isDisabled : elmTarget.hasClass('tooltip-disabled'),
      remoteURL: elmTarget.data('tooltip-url'),
      templateName: elmTarget.data('tooltip-template'),
      templateData: elmTarget.data('tooltip-template-data'),
      convertNewLines : elmTarget.hasClass('tooltip-convert-newlines'),
      gravity : gravity,
      className : className,
      opacity: opacity,
      style: tooltipStyle,
      maxWidth : maxWidth,
      offset : offset
    });

    var tipsy = $.data(ele, 'tipsy');
    if (!tipsy) {
      tipsy = new Tipsy(ele, currentOptions);
      $.data(ele, 'tipsy', tipsy);
    }
    return tipsy;
  }

  function onMouseEnter(elmTarget, e) {

    hideAll();

    var tipsy = get(this);
    tipsy.hoverState = 'in';

    if( tipsy.options.isDisabled ) {
      tipsy.disable();
    } else {
      tipsy.enable();
    }

    if( tipsy.options.isDelayed ) {

      tipsy.clearTimer();
      tipsy.timer = setTimeout(function() {
        tipsy.show();
      }, tipsy.options.delayInMs || 500);

    } else {

      if (tipsy.options.isRemote && !tipsy.options.templateData && !tipsy.fetchingRemote) {
        tipsy.fetchingRemote = true;

        transport.getJSON(tipsy.options.remoteURL, {}, function(responseData){
          tipsy.options.templateData = _.map(responseData.data.tooltip_data, function(v) {
            return _.escape(v);
          });
          if (tipsy.hoverState === 'in') {
            tipsy.show();
          }
          tipsy.fetchingRemote = false;
        });

      }
      else {
        tipsy.show();
      }
    }
  }

  function onMouseLeave(elmTarget, e) {
    var tipsy = get(this);

    tipsy.clearTimer();
    tipsy.hoverState = 'out';
    tipsy.hide();
  }

  function onMouseClick(elmTarget, e) {
    var tipsy = get(this);

    tipsy.clearTimer();
  }

  function clearRemoteData(elmTarget) {
    var tipsy = get(elmTarget);
    tipsy.clearRemoteData();
  }

  function onScroll() {
    hideAll();
  }

  function hideAll() {
    $('.tipsy').remove();
    $(window).unbind('scroll', onScroll);
    scrollEventBound = false;
  }

  function gravityAutoBounds() {
    var targetRightBound = $(this).bounds().right;
    var documentRightBound = $('body').bounds().right - 150;

    return ( targetRightBound > documentRightBound ) ? 'ne' : 'n';
  }

  eventUI.bind('mouseenter', options.selector, onMouseEnter, true);
  eventUI.bind('mouseleave', options.selector, onMouseLeave, true);
  eventUI.bind('click', options.selector, onMouseClick, true);

  return {
    hideAll : hideAll,
    clearRemoteData: clearRemoteData
  };

});

